<template>
  <div
    class="flex flex-col flex-1 rounded-xl m-5 p-4 h-full overflow-hidden"
  >
    <div class="flex justify-between items-center mb-4 flex-shrink-0">
      <reports-filters
        :showCallType="true"
        :showNumber="true"
        @submitReport="getCallsResult"
      ></reports-filters>
    </div>

    <div class="flex-1 overflow-hidden flex flex-col">
      <div class="flex-1 overflow-auto">
        <DataTable :value="callRepos">
      <template #empty>
        <p class="text-primary-900 text-sm text-center">
          {{ $t("reports.agent_calls_report.no_calls") }}
        </p>
      </template>
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium rounded-s-lg text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="time"
        :header="$t('reports.agent_calls_report.head_date')"
      >
        <template #body="slotProps">
          {{ formatDate(slotProps.data.time) }}
        </template></Column
      >
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="src"
        :header="$t('reports.agent_calls_report.head_src')"
        ><template #body="slotProps">
          {{
            slotProps.data.call_type == 2
              ? slotProps.data.dst
              : slotProps.data.src
          }}
        </template></Column
      >
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="call_type "
        :header="$t('reports.agent_calls_report.head_call_type')"
      >
        <template #body="slotProps">
          <span
            :class="`${
              callType(slotProps.data.call_type).class
            } w-fit py-1 px-2 rounded-md `"
          >
            <v-icon :class="`mdi ${callType(slotProps.data.call_type).icon}`" />
            {{ callType(slotProps.data.call_type).type }}
          </span>
        </template>
      </Column>
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="duration"
        :header="$t('reports.agent_calls_report.head_duration')"
      ></Column>
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium rounded-e-lg text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="reason"
        :header="$t('reports.agent_calls_report.head_reason')"
      >
        <template #body="slotProps">
          <Button
            class="bg-white text-xs hover:!bg-primary-900 hover:!text-white px-2 py-1 rounded-lg text-primary-900 border-solid border-primary-900 border"
            @click="
              showReasonDialog = true;
              selectedCall = {
                ...slotProps.data,
                number:
                  slotProps.data.call_type == 1
                    ? slotProps.data.src
                    : slotProps.data.dst,
              };
            "
          >
            <v-icon v-if="slotProps.data.reasons && slotProps.data.reasons.length > 0"
              >mdi-pencil</v-icon
            >
            <span v-else>
              {{ $t("calls.reasons.add_reason") }}
            </span>
          </Button>
          <v-tooltip
            v-if="slotProps.data.reasons && slotProps.data.reasons.length > 0 && slotProps.data.reasons[0]"
            :text="slotProps.data.reasons[0]"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <span v-bind="props" class="text-primary-900 ml-2 cursor-pointer">
                {{ getLastReasonPart(slotProps.data.reasons[0]) }}
              </span>
            </template>
          </v-tooltip>
          <span v-else class="text-primary-900 ml-2">-</span>
        </template>
      </Column>
        </DataTable>
      </div>
    
      <!-- Pagination -->
      <div class="flex-shrink-0 bg-white border-t border-gray-200 shadow-sm mt-4">
        <div class="px-3 py-2">
          <report-pagination
            :current-page="page"
            :total-pages="paginationLength"
            :total-count="count"
            :records-per-page="limit"
            :available-limits="[10, 25, 50, 100]"
            :show-records-per-page="true"
            :show-pagination-info="true"
            :show-jump-to-page="false"
            @page-change="goToPage"
            @records-per-page-change="handleRecordsPerPageChange"
          />
        </div>
      </div>
    </div>
  </div>
  <Dialog
    class="w-1/2 h-3/4"
    v-model:visible="showReasonDialog"
    :header="
      selectedCall?.reasons && selectedCall?.reasons.length > 0
        ? $t('calls.reasons.edit_reason_btn')
        : $t('calls.reasons.add_reason')
    "
    :modal="true"
  >
    <NewCallReasons
      class="h-full"
      :call="selectedCall"
    />
  </Dialog>
</template>

<script>
import ReportsFilters from "../../../components/ReportsFilters.vue";
import ReportPagination from "@/pages/reports/components/ReportPagination.vue";
import { mapActions } from "vuex";
import { DataTable, Column, Button, Dialog } from "primevue";
import { formatDate } from "@/utils";
import moment from "moment";
import NewCallReasons from "@/pages/call/components/NewCallReasons.vue";

export default {
  name: "agent-call-report",
  data() {
    return {
      count: 0,
      showProgress: false,
      limit: 10,
      filters: null,
      page: 1,
      lastIndex: 1,
      firstIndex: 1,
      showCount: false,
      paginationLength: 1,
      callRepos: [],
      isSubmit: false,
      showReasonDialog: false,
      selectedCall: null,
    };
  },
  components: {
    ReportsFilters,
    ReportPagination,
    DataTable,
    Column,
    Button,
    Dialog,
    NewCallReasons,
  },
  methods: {
    ...mapActions([
      "GetAgentCalls",
      "ShowProgressBar",
      "SetMessageDialog",
      "GetCallReasons",
    ]),
    toArabicNumerals(num) {
      return num
        .toString()
        .replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d])
        .replace(/\./g, "٫");
    },
    async getCallsResult(sentFilters) {
      let payload = {
        from: sentFilters.from,
        to: sentFilters.to,
        callType: sentFilters.callType == "All" ? "0" : sentFilters.callType,
        number: sentFilters.number == "" ? "0" : sentFilters.number,
        offset: this.page - 1,
        limit: this.limit,
        export: sentFilters.export,
      };
      this.filters = payload;
      this.page = 1;
      await this.getPageData(true);
    },
    async getPageData(newReq) {
      this.showProgress = true;
      try {
        var getcount = newReq ? 1 : 0;
        this.isSubmit = newReq;
        this.filters.iscount = getcount;
        this.filters.offset = (this.page - 1) * this.limit;
        var resp = await this.GetAgentCalls(this.filters);
        this.isSubmit = false;
        this.showProgress = false;
        if (!this.filters.export || resp)
          if (!resp.success) {
            this.SetMessageDialog({ show: true, message: resp.message });
          } else {
            this.callRepos = resp.calls;
            if (newReq) {
              this.count = resp.count;
              this.showCount = true;
              this.setPaginations();
            }
            // this.showProgress = false;
          }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.showProgress = false;
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    setPaginations() {
      var pageCount = Math.floor(this.count / this.limit);
      pageCount = pageCount > 1 ? pageCount : 1;
      if (
        pageCount >= 1 &&
        this.count > this.limit &&
        this.count % this.limit > 0
      ) {
        pageCount++;
      }

      this.paginationLength = pageCount;
    },
    setMDN(call) {
      if (call.call_type == 1) {
        return call.src;
      } else if (call.call_type == 2) {
        return call.dst;
      } else {
        return call.dst;
      }
    },
    callType(type) {
      if (type == 1) {
        return {
          type: this.$t("reports.agent_calls_report.calltype_incoming"),
          icon: "mdi-phone-incoming",
          class: "bg-primary-100 text-primary-500",
        };
      } else if (type == 2) {
        return {
          type: this.$t("reports.agent_calls_report.calltype_outgoing"),
          icon: "mdi-phone-outgoing",
          class: "bg-orange-100 text-orange-red",
        };
      } else if (type == 3) {
        return {
          type: this.$t("reports.agent_calls_report.calltype_internal"),
          icon: "mdi-phone-refresh",
          class: "bg-gray-100 text-primary-900",
        };
      } else {
        return {
          type: this.$t("reports.agent_calls_report.calltype_dial"),
          icon: "mdi-phone-classic",
        };
      }
    },
    formatDate(date) {
      return formatDate(date);
    },
    getLastReasonPart(fullReason) {
      if (!fullReason) return '-';
      // Split by ' - ' separator and get the last part (leaf reason)
      const parts = fullReason.split(' - ');
      return parts[parts.length - 1] || fullReason;
    },
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.paginationLength) {
        this.page = pageNumber;
      }
    },
    handleRecordsPerPageChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.getPageData(true);
    },
  },
  computed: {
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  watch: {
    async page() {
      if (!this.isSubmit) {
        this.filters.export = false;
        await this.getPageData();
      }
    },
  },
  mounted() {
    this.getCallsResult({
      from: moment().format("YYYY-MM-DD") + " 00:00:00",
      to: moment().format("YYYY-MM-DD") + " 23:59:59",
      callType: "All",
      number: "",
    });
    if (!this.callReasons || this.callReasons.length === 0) {
      this.GetCallReasons();
    }
  },
};
</script>
<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}

/* Center header text in PrimeVue DataTable */
:deep(.p-datatable-thead th.text-center .p-datatable-column-header-content) {
  justify-content: center;
}
</style>
